<mat-form-field class="timepicker">
  @if (label) {
  <mat-label>{{ label }}</mat-label>
  }
  <mat-select
    [disabled]="disabled"
    [value]="value"
    (valueChange)="onValueChange($event)"
  >
    @for (option of dropdownOptions; track option.value) {
    <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-select>
</mat-form-field>
